export type ExpertLevel = 'easy' | 'advanced' | 'expert';

export interface FeatureConfig {
  showQuickAddTask: boolean;
  showQuickAddPicture: boolean;
  showMainFilters: boolean;
  showSnoozedToggle: boolean;
  showTvModeIcon: boolean;
  showTeamSwitcher: boolean;
  showCustomEntityStates: boolean;
}

export const EXPERT_LEVEL_CONFIG: Record<ExpertLevel, FeatureConfig> = {
  easy: {
    showQuickAddTask: true,
    showQuickAddPicture: true,
    showMainFilters: true,
    showSnoozedToggle: true,
    showTvModeIcon: true,
    showTeamSwitcher: true,
    showCustomEntityStates: false,
  },
  advanced: {
    showQuickAddTask: true,
    showQuickAddPicture: true,
    showMainFilters: true,
    showSnoozedToggle: true,
    showTvModeIcon: true,
    showTeamSwitcher: true,
    showCustomEntityStates: false,
  },
  expert: {
    showQuickAddTask: true,
    showQuickAddPicture: true,
    showMainFilters: true,
    showSnoozedToggle: true,
    showTvModeIcon: true,
    showTeamSwitcher: true,
    showCustomEntityStates: true,
  },
};

export const EXPERT_LEVEL_INFO: Record<ExpertLevel, { labelKey: string; descKey: string; icon: string }> = {
  easy: {
    labelKey: 'settings.general.expertMode.easy.label',
    descKey: 'settings.general.expertMode.easy.desc',
    icon: '🐣'
  },
  advanced: {
    labelKey: 'settings.general.expertMode.advanced.label',
    descKey: 'settings.general.expertMode.advanced.desc',
    icon: '🚀'
  },
  expert: {
    labelKey: 'settings.general.expertMode.expert.label',
    descKey: 'settings.general.expertMode.expert.desc',
    icon: '⚡'
  }
};
